import { Component } from '@angular/core';
import { DataServiceService } from '../../services/data-service.service';

@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrl: './service.component.scss'
})
export class ServiceComponent {
  serviceDataSource: any;

  constructor(private dataService: DataServiceService) {
    this.serviceDataSource = dataService.getServiceDataSource();
  }

}
